import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogContent, Stack, Typography, Button, CircularProgress,
  TextField, Switch, FormControlLabel, Box
} from '@mui/material';

export default function ClosureEmployeeAccountingModal({
  open, onClose, employee, onSave, saving,
}) {
  const [cuit, setCuit] = useState('');
  const [bank, setBank] = useState('');
  const [cvu, setCvu] = useState('');
  const [accountAlias, setAccountAlias] = useState('');
  const [updateProfileAlso, setUpdateProfileAlso] = useState(false);

  useEffect(() => {
    if (open && employee) {
      setCuit(employee.cuitSnapshot || '');
      setBank(employee.bankSnapshot || '');
      setCvu(employee.cvuSnapshot || '');
      setAccountAlias(employee.accountAliasSnapshot || '');
      setUpdateProfileAlso(false); // Por defecto no pisa el legajo base
    }
  }, [open, employee]);

  const handleSave = () => {
    onSave({
      cuitSnapshot: cuit.trim(),
      bankSnapshot: bank.trim(),
      cvuSnapshot: cvu.trim(),
      accountAliasSnapshot: accountAlias.trim(),
      updateProfileAlso,
    });
  };

  return (
    <Dialog
      open={open}
      onClose={saving ? undefined : onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { bgcolor: 'white', borderRadius: '24px', p: 1 } }}
    >
      <DialogContent sx={{ p: 3, display: 'flex', flexDirection: 'column', gap: 3 }}>
        
        <Box sx={{ pb: 1, borderBottom: '1px solid', borderColor: 'neutral.200' }}>
          <Typography sx={{ fontSize: 18, fontWeight: 700, color: 'primary.900' }}>
            Información de Pago - {employee?.fullName}
          </Typography>
        </Box>

        <Stack spacing={2}>
          <TextField
            label="CUIT/CUIL"
            variant="outlined"
            value={cuit}
            onChange={(e) => setCuit(e.target.value)}
            disabled={saving}
            size="small"
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
          />
          <TextField
            label="Banco"
            variant="outlined"
            value={bank}
            onChange={(e) => setBank(e.target.value)}
            disabled={saving}
            size="small"
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
          />
          <TextField
            label="CVU / CBU"
            variant="outlined"
            value={cvu}
            onChange={(e) => setCvu(e.target.value)}
            disabled={saving}
            size="small"
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
          />
          <TextField
            label="Alias de la cuenta"
            variant="outlined"
            value={accountAlias}
            onChange={(e) => setAccountAlias(e.target.value)}
            disabled={saving}
            size="small"
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
          />
        </Stack>

        <Box sx={{ bgcolor: 'secondary.50', p: 1.5, borderRadius: '12px', border: '1px solid', borderColor: 'secondary.200' }}>
          <FormControlLabel
            control={
              <Switch 
                checked={updateProfileAlso} 
                onChange={(e) => setUpdateProfileAlso(e.target.checked)} 
                color="primary"
                disabled={saving}
              />
            }
            label={
              <Typography sx={{ fontSize: 13, fontWeight: 600, color: 'primary.900' }}>
                Actualizar también el legajo de este empleado para futuras liquidaciones
              </Typography>
            }
            sx={{ m: 0 }}
          />
        </Box>

        <Stack direction="row" sx={{ justifyContent: 'flex-end', gap: 1.5 }}>
          <Button
            onClick={onClose} disabled={saving} variant="outlined" 
            sx={{ textTransform: 'none', borderRadius: '24px', px: 3, py: 0.6, fontSize: 14, color: 'primary.900', borderColor: 'neutral.400', fontWeight: 700 }}
          >
            Cancelar
          </Button>

          <Button
            onClick={handleSave} disabled={saving} variant="contained" color="primary" 
            sx={{ textTransform: 'none', borderRadius: '24px', px: 3, py: 0.6, fontSize: 14, fontWeight: 700, display: 'flex', gap: 1 }}
          >
            {saving ? <CircularProgress size={18} color="inherit" /> : 'Guardar'}
          </Button>
        </Stack>

      </DialogContent>
    </Dialog>
  );
}